module.exports = __webpack_public_path__ + "img/live_sky.41ad6891.png";